import { Capacitor, Plugin, registerPlugin } from '@capacitor/core'
import { setCurrentChatRoomId } from '@dinosband/bv-messenger-controller'

interface PageCallPlugin extends Plugin {
  openPageCall(args: { src: string, title: string }): void
}

export const pageCall = registerPlugin<PageCallPlugin>('PageCallPlugin')

let _chatroomId = undefined as number | undefined
export function openPageCallPlugin (src: string, title: string, chatroomId?: number) {
  if (!Capacitor.isNativePlatform()) {
    return
  }
  _chatroomId = chatroomId
  if (_chatroomId) {
    setCurrentChatRoomId()
  }
  pageCall.openPageCall({ src, title })
}

export function addPageCallListeners () {
  if (Capacitor.isNativePlatform() && Capacitor.getPlatform() == 'ios') {
    pageCall.addListener('closed', () => {
      if (_chatroomId) {
        setCurrentChatRoomId(_chatroomId)
        _chatroomId = undefined
      }
    })
  }
}

if (process.env.NODE_ENV != 'test') {
  addPageCallListeners()
}
